// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8751) return "static/chunks/8751.3119e08f0f0b950d.js";
	if (chunkId === 7884) return "static/chunks/7884.62eb71133014655c.js";
	if (chunkId === 5503) return "static/chunks/5503.610d1192eadf6ddf.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"117":"c85d253b708676e9","1073":"10374cdfac7b4525","2340":"7dcdf8ae9e42251a","4610":"811b8942400ece8e","5740":"7801081a059ba626"}[chunkId] + ".js";
};